/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";

const AddLinkButton = (props) => {
    const setOpen = props?.setOpen;

    const openDialog = () => {
        if (setOpen) {
            setOpen(true);
        }
    };

    return (
        <div 
            className="banner-add-link-button"
            onClick={openDialog}
        >
            <div className="banner-add-link-button-text">Select Link</div>
        </div>
    );
};

AddLinkButton.displayName = "AddLinkButton";
export { AddLinkButton };

